export default __webpack_public_path__ + "static/media/step_A_UA.c928f461.png";